import React from 'react';
import styled from 'styled-components';

import { ReactElement } from 'react';
import { Issue } from '../types';
import Drawer from './common/Drawer';
import GenerateForm from './common/GenerateForm';

type OpenCustomerQuestionsDrawerProps = {
  open: boolean;
  onClose: () => void;
  issue?: Issue;
  onSubmit: (text: string) => void;
  onUpdate: (text: string) => void;
  generatedMessage?: string;
  loading: boolean;
};

const Container = styled.div`
  margin-bottom: 20px;
`;

const TextBlock = styled.div`
  margin-bottom: 20px;
`;

const HighlightedText = styled.div`
  border: 2px solid #e4e5e7;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 20px;
`;

const IssueName = styled.div`
  font-weight: bold;
  margin-bottom: 10px;
`;

const OpenCustomerQuestionsDrawer = ({
  open,
  onClose,
  issue,
  onSubmit,
  onUpdate,
  generatedMessage,
  loading,
}: OpenCustomerQuestionsDrawerProps): ReactElement => {
  return (
    <Drawer header={'Generate a message'} open={open} onClose={(): void => onClose()}>
      <Container>
        <TextBlock>Generating a response for the following issue:</TextBlock>
        <HighlightedText>
          <IssueName>{issue?.issueTopic}</IssueName>
          <div>{issue?.description}</div>
        </HighlightedText>
        <GenerateForm
          generatedMessage={generatedMessage}
          onSubmit={onSubmit}
          onUpdate={onUpdate}
          loading={loading}
        />
      </Container>
    </Drawer>
  );
};

export default OpenCustomerQuestionsDrawer;
